export const NE_WELCOME_CREDIT_PROMOTION = 'br-welcome-credit';

export enum NE_TYPE_OF_PAYMENT_PROMOTION {
  PRE_PAID = 'PrePaid',
  POST_PAID = 'PostPaid',
}

export const NE_POST_PAID_SHIPPING_CONCEPT_CODES = new Set([
  'shipping-fee',
  'shipping-cost',
  'shipping-cost-carrier',
  'shipping-penalty',
]);

export enum NE_PRINT_LABEL_SOURCE {
  ORDERS_LIST = 'OrdersList',
  ORDER_DETAILS = 'OrderDetails',
}

export enum NE_DISPLAY_SWITCHES {
  SHOW_LOGGI_ACTIVATION_BANNER = 'showLoggiActivationBanner',
  SHOW_NE_NUDGE_IN_ORDERS_POPOVER = 'showNeNudgeInOrdersPopover',
  WELCOME_CREDIT_PROMOTION_BANNER = 'welcomeCreditPromotionBanner',
}

export const NE_PRINT_LABEL_LIMIT_TEMP = 50;
